export const hourFormat = time => {
    let format = new Date(time);
    let hour  = format.getHours();
    let minutes  = format.getMinutes();
    hour = ("0" + hour).slice(-2);
    minutes = ("0" + minutes).slice(-2);
  
    return `${hour}:${minutes}`;
}

export const dateFormatDDmesAnio = time => {
    let format = new Date(time);
    var month = format.toLocaleDateString('es-ES', { month: "long" });
    month = month.charAt(0).toUpperCase() + month.slice(1);
    var day   = format.toLocaleDateString('es-ES', { day: "numeric" });
    var year   = format.toLocaleDateString('es-ES', { year: "numeric" });
    return `${day} ${month}, ${year}`;
}

export const generateSessionId = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
}